var PressureUnit_1;
import { __decorate } from "tslib";
import { Unit } from './Unit';
import { SerializableObject } from '../../data/decorators';
/**
 * @category Unit
 */
let PressureUnit = PressureUnit_1 = class PressureUnit extends Unit {};
PressureUnit.PASCAL = new PressureUnit_1('pascal', {
  baseName: 'pressure',
  aliases: ['P'],
  prefixes: 'decimal'
});
PressureUnit = PressureUnit_1 = __decorate([SerializableObject()], PressureUnit);
export { PressureUnit };